import {QuoteService} from "../../../domain/in/quote/quote-service";
import {EmployeeRoleEnum} from "../../../domain/enum/employee-role.enum";
import {TotalBillingStockAcMapper} from "./fr/ac/total-billing-stock-ac.mapper";

export class TotalBillingStockMapper {

    private totalBillingStockAcMapper: TotalBillingStockAcMapper;

    constructor() {
        this.totalBillingStockAcMapper = new TotalBillingStockAcMapper();
    }

    getTotalBillingStock(service: QuoteService, role: EmployeeRoleEnum, currency: string, locale: string) {
        switch (role) {
            case EmployeeRoleEnum.AC:
            case EmployeeRoleEnum.CRV_PRO:
                return this.totalBillingStockAcMapper.getTotalBillingStock(service, currency, locale);
            default:
                return '';
        }
    }
}
